// src/utils/idle.js
let timer = null
// 与后端 Redis Token TTL（2 小时）一致，略短 1 分钟避免边界竞态
let timeoutMs = (2 * 60 * 60 - 1) * 1000

export function startIdleDetection(onTimeout, onActivity) {
    // 清除已有计时器
    if (timer) {
        clearTimeout(timer)
    }

    // 设置新的计时器
    timer = setTimeout(() => {
        onTimeout()
    }, timeoutMs)

    if (onActivity) onActivity()
}

export function resetIdleTimer(onTimeout, onActivity) {
    startIdleDetection(onTimeout, onActivity)
}

export function stopIdleDetection() {
    if (timer) {
        clearTimeout(timer)
        timer = null
    }
}